import { render } from "./Part.vue?vue&type=template&id=fab3aa9a"
import script from "./Part.vue?vue&type=script&lang=js"
export * from "./Part.vue?vue&type=script&lang=js"
script.render = render

export default script